export default __webpack_public_path__ + "static/annotating-86d5d526e9e087383cfa91cad80fe59b.svg";